/**
 * Teacher-picker source — `location_teachers_today()` (SECURITY DEFINER,
 * scoped to the caller's own location via app_location_code(); no arg
 * needed). See public.location_teachers_today in
 * supabase/migrations/20260730131000_location_login_foundation.sql.
 */

import { supabase } from '@/integrations/supabase/client';
import type { LocationTeacherToday } from '../types';

interface LocationTeacherTodayRow {
  staff_id: string;
  first_name: string;
  full_name: string;
  tier: 'planned' | 'available';
  group_ids: string[] | null;
  /** rb3↔rb5 sibling toggle — not on every deployed server yet, tolerate missing. */
  group_location_codes?: string[] | null;
}

export async function getLocationTeachersToday(): Promise<LocationTeacherToday[]> {
  const { data, error } = await supabase.rpc('location_teachers_today');
  if (error) throw error;
  return ((data ?? []) as LocationTeacherTodayRow[]).map((row) => ({
    staffId: row.staff_id,
    firstName: row.first_name,
    fullName: row.full_name,
    tier: row.tier,
    groupIds: row.group_ids ?? [],
    groupLocationCodes: row.group_location_codes ?? [],
  }));
}
